module.exports = __webpack_public_path__ + "img/authorized-app.663315c7.svg";